import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    let active = false;
    let promotedLayer = false;
    let promotedLayerIndex = 0;

    const show = (key, element) => {
        if (!active) {
            active = true;
            promotedLayer = element;
            promotedLayerIndex = element.css('zIndex');
            promotedLayer.css('zIndex', 1001);
            TweenLite.to(el, 0.35, { autoAlpha: 0.8, ease: Quad.easeInOut });
        }
    };

    const hide = () => {
        if (active) {
            active = false;
            TweenLite.to(el, 0.2, { autoAlpha: 0, ease: Quad.easeOut, onComplete: () => { promotedLayer.css('zIndex', promotedLayerIndex); } });
        }
    };

    const click = () => {
        Dispatch.emit(Events.STICKIES_CLOSE);
        Dispatch.emit(Events.MENU_CLOSE);
        Dispatch.emit(Events.MOBILEMENU_CLOSE);
        Dispatch.emit(Events.FILTERS_CLOSE);
        Dispatch.emit(Events.PROJECTMENU_CLOSE);
    };

    const init = () => {
        Dispatch.on(Events.STICKIES_OPEN, show);
        Dispatch.on(Events.STICKIES_CLOSE, hide);
        Dispatch.on(Events.FILTERS_OPEN, show);
        Dispatch.on(Events.FILTERS_CLOSE, hide);
        Dispatch.on(Events.MENU_OPEN, show);
        Dispatch.on(Events.MENU_CLOSE, hide);
        Dispatch.on(Events.MOBILEMENU_OPEN, show);
        Dispatch.on(Events.MOBILEMENU_CLOSE, hide);
        Dispatch.on(Events.PROJECTMENU_OPEN, show);
        Dispatch.on(Events.PROJECTMENU_CLOSE, hide);
        dom.on('click', click);
    };

    const destroy = () => {
        Dispatch.off(Events.STICKIES_OPEN, show);
        Dispatch.off(Events.STICKIES_CLOSE, hide);
        Dispatch.off(Events.FILTERS_OPEN, show);
        Dispatch.off(Events.FILTERS_CLOSE, hide);
        Dispatch.off(Events.MENU_OPEN, show);
        Dispatch.off(Events.MENU_CLOSE, hide);
        Dispatch.off(Events.MOBILEMENU_OPEN, show);
        Dispatch.off(Events.MOBILEMENU_CLOSE, hide);
        Dispatch.off(Events.PROJECTMENU_OPEN, show);
        Dispatch.off(Events.PROJECTMENU_CLOSE, hide);
        dom.off('click', click);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Shader.js